import { store } from '@/appContext';

const transportationHubRoutes = [
  {
    path: '/transportation-hub/get-quote',
    component: () => import(
      /* webpackChunkName: "Transportation" */ '@/views/TransportationHub/GetQuote.vue'
    ),
    name: 'transportation-hub-get-quote',
    async beforeEnter(to, from, next) {
      const transportOpRefresh = await store.dispatch(
        'getFlag',
        store.state.featureFlags.featureFlagSlugs.transportOpRefresh,
      );

      if (transportOpRefresh) {
        next();
      } else {
        next({ path: '/transportation-hub' });
      }
    },
    meta: {
      title: 'Transportation Hub',
    },
  },
];

export default transportationHubRoutes;
